import React from 'react';
import Header from './components/Header';
import { Outlet } from 'react-router';
import Footer from './components/Footer';

const Layout = () => {
  return (
    <>
        <Header/>
        <div className='lg:mt-[82px] mt-[100px]'>
        <Outlet/>
        </div>
        <Footer/>
    </>
  )
}

export default Layout;